import { handleActions } from 'redux-actions'
import {
  SET_CYCLE_COUNTS,
  SET_CURRENT_CYCLE_COUNT,
  UPDATE_CYCLE_COUNT,
} from './cycleCountsActions'
import { ICycleCount } from '../types/cycle-counts'

export interface ICycleCountsState {
  cycleCounts: ICycleCount[]
  currentCycleCount: ICycleCount | null
}

const initialState: ICycleCountsState = {
  cycleCounts: [],
  currentCycleCount: null,
}

type CycleCountsPayload = ICycleCount | ICycleCount[]

export default handleActions<ICycleCountsState, CycleCountsPayload>(
  {
    [SET_CYCLE_COUNTS]: (state, { payload }) => ({
      ...state,
      cycleCounts: payload as ICycleCount[],
    }),
    [SET_CURRENT_CYCLE_COUNT]: (state, { payload }) => ({
      ...state,
      currentCycleCount: payload as ICycleCount,
    }),
    [UPDATE_CYCLE_COUNT]: (state, { payload }) => {
      const cycleCount = payload as ICycleCount
      const index = state.cycleCounts.findIndex((cc) => cc.id === cycleCount.id)
      let updatedCycleCounts = state.cycleCounts
      if (index !== -1) {
        updatedCycleCounts = [...state.cycleCounts]
        updatedCycleCounts[index] = cycleCount
      } else {
        updatedCycleCounts = [...state.cycleCounts, cycleCount]
      }
      return {
        ...state,
        cycleCounts: updatedCycleCounts,
        currentCycleCount:
          state.currentCycleCount?.id === cycleCount.id
            ? cycleCount
            : state.currentCycleCount,
      }
    },
  },
  initialState,
)
